// utils/analyticsTimers.js
let sessionStart = null;

export const startSessionTimer = () => {
  sessionStart = Date.now();
};

export const stopSessionTimer = () => {
  if (sessionStart) {
    const duration = Math.round((Date.now() - sessionStart) / 1000);
    import('./analytics').then(({ trackEvent }) => trackEvent('session_duration', { seconds: duration }));
    sessionStart = null;
  }
};
